import Auth from './auth';
import Basket from './basket';
import Buttons from './buttons';
import Cashback from './cashback';
import Carousel from './carousel';
import Checkout from './checkout';
import Company from './company';
import Delivery from './delivery';
import Footers from './footers';
import Internet from './internet';
import Legal from './legal';
import Loading from './loading';
import Marketing from './marketing';
import Menu from './menu';
import Navigation from './navigation';
import OrderType from './order-type';
import Payment from './payment';
import Profile from './profile';
import MetaInfo from './MetaInfo';
import Note from './note';
import Order from './order';
import CookieConsent from './CookieConsent';
import Headers from './headers';
import Labels from './labels';

export default {
  Auth,
  Basket,
  Buttons,
  Carousel,
  Cashback,
  Checkout,
  Company,
  Delivery,
  Footers,
  Internet,
  Legal,
  Loading,
  Marketing,
  Menu,
  Navigation,
  OrderType,
  Payment,
  Profile,
  MetaInfo,
  Note,
  Order,
  CookieConsent,
  Headers,
  Labels,
};
